import React, { useEffect, useState, useMemo } from "react";
import MPHeader1 from "./MainPageComps/MPHeader1";

import MPBlock1 from "./MainPageComps/MPBlock1";
import MPBlock2 from "./MainPageComps/MPBlock2";
import MPHeader3 from "./MainPageComps/MPHeader3";
import MPBody from "./MainPageComps/MPBody";
import MPFooter from "./MainPageComps/MPFooter";

export default function MainPage() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        paddingLeft:
          windowWidth <= 1024
            ? "0%"
            : windowWidth <= 1920
              ? "10%"
              : windowWidth <= 2560
                ? "20%"
                : windowWidth <= 3840
                  ? "25%"
                  : "30%",
        paddingRight:
          windowWidth <= 1024
            ? "0%"
            : windowWidth <= 1920
              ? "10%"
              : windowWidth <= 2560
                ? "20%"
                : windowWidth <= 3840
                  ? "25%"
                  : "30%",
        justifyContent: "center",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <MPHeader1 />
      <MPHeader3 />

      <MPBlock1 />
      {/* <MPBlock2 /> */}

      <MPBody />
      {/* <MPFooter /> */}
    </div>
  );
}
